import { createSlice } from '@reduxjs/toolkit'
import { AppThunk } from '../rootReducer'
import { IProgram } from './interfaces'
import moment from 'moment'

export const initialState = {
  data: {} as IProgram,
  loaded: false,
  error: false,
  answeredParticipantCustomQuestions: [] as number[],
}

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    setProgram(state, action) {
      state.data = action.payload
      state.loaded = true
    },
    loadingFailed(state, action) {
      state.loaded = false
      state.error = action.payload
      state.data = {} as IProgram
    },
    setAnsweredParticipantCustomQuestions(state, action) {
      state.answeredParticipantCustomQuestions = action.payload
    },
  },
})

export default programSlice.reducer
export const {
  setProgram,
  loadingFailed,
  setAnsweredParticipantCustomQuestions,
} = programSlice.actions

export const fetchProgram = (): AppThunk => async (dispatch, getState) => {
  console.log('Fetching program...')
  try {
    const { baseUrl, programId } = getState().misc

    // Initiate both fetch requests in parallel
    const [normalResponse, extendedResponse] = await Promise.all([
      fetch(`${baseUrl}/api/programs/${programId}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }),
      fetch(`${baseUrl}/api/programs/${programId}/extended`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        //@ts-ignore
        credentials: window._is_react_dev_server ? "include" : "same-origin",
      })
    ])

    // Check if responses are OK
    if (!(normalResponse.ok )) {
      throw new Error(`Failed to fetch normal program data: ${normalResponse.statusText}`)
    }
    if (!extendedResponse.ok ) {
      throw new Error(`Failed to fetch extended program data: ${extendedResponse.statusText}`)
    }

    // Parse JSON responses
    const normalData = await normalResponse.json()
    const extendedData = await extendedResponse.json()

    // Combine data and dispatch
    const allData = {
      ...normalData,
      ...extendedData,
    }
    allData.hide_event_occupation =
      moment(allData.last_registration_date) < moment() &&
      allData.hide_booking_after_program_end
    return dispatch(setProgram(allData))
  } catch (error: unknown) {
    if (error instanceof Error) {
      return dispatch(loadingFailed(error.toString()))
    } else if (typeof error === 'string') {
      return dispatch(loadingFailed(error))
    }
  }
}
